import CalendlyWidget from '../components/CalendlyWidget'
import './BookingPage.css'

function BookingPage() {
  // Replace 'your-calendly-username' with your actual Calendly username
  // Replace 'consultation' with your actual event type slug
  // Example: 'https://calendly.com/labspecialists/consultation'
  // In Vite, use VITE_ prefix for environment variables
  const CALENDLY_URL = import.meta.env.VITE_CALENDLY_URL || 'https://calendly.com/your-calendly-username/consultation'

  return (
    <div className="booking-page">
      <section className="page-hero">
        <div className="container">
          <h1>Schedule Your Free Consultation</h1>
          <p className="page-hero-subtitle">
            Get expert advice on your lab equipment needs - no obligation, just professional guidance
          </p>
        </div>
      </section>

      <section className="booking-content">
        <div className="container">
          <div className="booking-intro">
            <h2>What to Expect</h2>
            <p>
              During your free 15-minute consultation, we'll discuss your lab equipment needs, 
              answer your questions, and provide expert recommendations tailored to your situation.
            </p>
            <ul className="booking-benefits">
              <li>✓ Free consultation with no obligation</li>
              <li>✓ Expert advice from experienced professionals</li>
              <li>✓ Customized recommendations for your needs</li>
              <li>✓ Quick assessment of your requirements</li>
              <li>✓ Transparent pricing and next steps</li>
            </ul>
            <p className="booking-alternative">
              Prefer to reach out directly? You can also{' '}
              <a href="tel:+15416589374">text or call us at (541) 658-9374</a>.
            </p>
          </div>

          <div className="booking-form-wrapper">
            <CalendlyWidget 
              url={CALENDLY_URL}
              pageSettings={{
                backgroundColor: 'ffffff',
                hideEventTypeDetails: false,
                hideLandingPageDetails: false,
                primaryColor: '1e40af', // Your primary blue color
                textColor: '1f2937' // Your text color
              }}
            />
          </div>
        </div>
      </section>
    </div>
  )
}

export default BookingPage
